import { createAction, props } from '@ngrx/store';

export const getGeozones = createAction('[Geozones] Get');
export const storeGeozones = createAction('[Geozones] Store', props<{ list: any }>());
